"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = require("../../svg");

var _variables = require("../../styles/variables");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["onDelete", "color", "variant", "label"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  sm: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 4px 7px;\n    font-size: 10px;\n  "]))),
  md: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 5px 12px;\n    font-size: 12px;\n  "]))),
  lg: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 8px 15px;\n    font-size: 14px;\n  "])))
};
var variant = {
  outlined: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), _variables.colors.ghost, function (_ref) {
    var color = _ref.color;
    return color && _variables.colors[color];
  }),
  filled: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_ref2) {
    var color = _ref2.color;
    return _variables.colors[color];
  }, _variables.colors.ghost),
  dimm: (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_ref3) {
    var color = _ref3.color;
    return _variables.colors[color] + "25";
  }, function (_ref4) {
    var color = _ref4.color;
    return _variables.colors[color];
  })
};

var StyledChip = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: fit-content;\n  font-family: IranSansX;\n  border-radius: 20px;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: ", ";\n  ", ";\n  ", ";\n"])), function (_ref5) {
  var color = _ref5.color;
  return "1px ".concat(_variables.colors[color] + "30", " solid");
}, function (props) {
  return sizes[props.size];
}, function (props) {
  return variant[props.variant];
});

var StyledIcon = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 13px;\n  height: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -2px;\n  margin-right: 10px;\n  & svg {\n    & path {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return props.variant === "filled" ? "#fff" : _variables.colors[props.color];
});

var Chip = function Chip(props) {
  var onDelete = props.onDelete,
      color = props.color,
      variant = props.variant,
      label = props.label,
      htmlAttributes = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledChip, _extends({
    variant: variant,
    color: color
  }, htmlAttributes), onDelete && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    onClick: onDelete,
    color: color,
    variant: variant,
    "data-testid": props["data-testid"]
  }, _svg.CloseIcon), label);
};

exports.Chip = Chip;
Chip.propTypes = {
  variant: _propTypes["default"].oneOf(["outlined", "filled", "dimm"]),
  size: _propTypes["default"].oneOf(["sm", "md", "lg"]),
  onDelete: _propTypes["default"].func,
  className: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  label: _propTypes["default"].string
};
Chip.defaultProps = {
  size: "md",
  variant: "outlined",
  color: "father"
};